const LoginURL = 'http://sit.botingliving.com';
// const LoginURL = 'http://192.168.7.194:8086';
// const LoginURL = 'http://192.168.7.197:8086';
const LoginURL2 = 'http://41.204.2.91:7889';
// const LoginURL2 = 'http://192.168.7.175:7889';
export default {
  LoginURL,
  LoginURL2
}